<a
    [href]="githubUrl"
    class="pill pill--github">
    <i class="uil uil-github"></i>
    Github
</a>
